import Immutable from 'immutable';
import React from 'react';
import {
  ROUTE_SSO,
  ROUTE_COURSES,
  ROUTE_CERTIFICATE_VERIFICATION_PAGE,
  ROUTE_CREATE_COURSE_PAGE,
  ROUTE_CONTACT_PAGE,
  ROUTE_PARTNERS_LISTING_PAGE,
} from '../../../../ReduxStorage/routeActions';
import { FooterLink } from '../../../components/PageFooter/FooterLink';
import { FontAwesome } from '../../../components/FontAwesome';

import './styles.scss';
import {
  TOS_GENERAL_URL,
  PRIVACY_POLICY_URL,
  HELP_ORIGIN,
  SOLUTIONS_ORIGIN,
} from '../../../../constants';

const copyrightYear = new Date().getFullYear();

const footerData = Immutable.fromJS([
  {
    title: 'Tools & Resources',
    links: [
      {
        text: 'Help & Support',
        action: {
          type: ROUTE_SSO,
          params: {
            action: 'help',
          },
          query: {
            url: `${HELP_ORIGIN}/`,
          },
        },
        target: '_blank',
      },
      {
        text: 'Contact us',
        action: {
          type: ROUTE_CONTACT_PAGE,
        },
      },
      {
        text: 'Learning design toolkit',
        href: 'https://medium.com/learning-designers-toolkit',
        target: '_blank',
      },
      {
        text: 'Verify a certificate',
        action: {
          type: ROUTE_CERTIFICATE_VERIFICATION_PAGE,
        },
      },
      {
        text: 'Integrations',
        action: {
          type: ROUTE_SSO,
          params: {
            action: 'help',
          },
          query: {
            url: `${HELP_ORIGIN}/category/integrations`,
          },
        },
        target: '_blank',
      },
      {
        text: 'Status',
        href: 'https://status.openlearning.com/',
        target: '_blank',
      },
    ],
  },
  {
    title: 'Platform',
    links: [
      {
        text: 'Philosophy',
        href: `${SOLUTIONS_ORIGIN}/learning-philosophy/`,
      },
      {
        text: 'Features',
        href: `${SOLUTIONS_ORIGIN}/platform-features/`,
      },
      {
        text: 'Pricing',
        href: `${SOLUTIONS_ORIGIN}/pricing/`,
      },
      {
        text: 'OpenCreds',
        href: `${SOLUTIONS_ORIGIN}/opencreds/`,
      },
      {
        text: 'Partners',
        action: {
          type: ROUTE_PARTNERS_LISTING_PAGE,
        },
      },
      {
        text: 'Browse all courses',
        action: {
          type: ROUTE_COURSES,
        },
      },
      {
        text: 'Create a course',
        action: {
          type: ROUTE_CREATE_COURSE_PAGE,
        },
      },
    ],
  },
  {
    title: 'Company',
    links: [
      {
        text: 'About us',
        href: `${SOLUTIONS_ORIGIN}/about/`,
      },
      {
        text: 'Team',
        href: `${SOLUTIONS_ORIGIN}/teams/`,
      },
      {
        text: 'Careers',
        href: `${SOLUTIONS_ORIGIN}/careers/`,
      },
      {
        text: 'Press',
        href: `${SOLUTIONS_ORIGIN}/press/`,
      },
      {
        text: 'Investors',
        href: `${SOLUTIONS_ORIGIN}/investor-home/`,
      },
      {
        text: 'Partnerships',
        href: `${SOLUTIONS_ORIGIN}/contact`,
        target: '_blank',
      },
    ],
  },
]);

const socialMediaLinks = Immutable.fromJS([
  {
    icon: 'twitter',
    text: 'Twitter',
    href: 'https://twitter.com/openlrning',
  },
  {
    icon: 'instagram',
    text: 'Instagram',
    href: 'https://www.instagram.com/openlearning_global',
  },
  {
    icon: 'facebook-square',
    text: 'Facebook',
    href: 'https://facebook.com/OpenLearning',
  },
  {
    icon: 'linkedin-square',
    text: 'LinkedIn',
    href: 'https://www.linkedin.com/company/openlearningcom/',
  },
  {
    icon: 'youtube-play',
    text: 'YouTube',
    href: 'https://www.youtube.com/user/openlearningcom',
  },
]);

// TODO: replace this footer with the new HomePage/Footer after OpenCreds launch
export const DefaultFooter = () => {
  return (
    <default-footer>
      <div className="row">
        <div className="columns large-10 large-centered medium-10 medium-centered">
          <div className="footer-columns">
            {footerData.map((column, i) => {
              const columnIndex = i;
              return (
                <div
                  key={`footer-column-${columnIndex}`}
                  className="footer-column"
                >
                  <ul>
                    <li>
                      <strong className="column-title">
                        {column.get('title')}
                      </strong>
                    </li>
                    {column.get('links').map((link, j) => {
                      const rowIndex = j;
                      return (
                        <li key={`footer-link-${rowIndex}`}>
                          <FooterLink {...{ link }} />
                        </li>
                      );
                    })}
                  </ul>
                </div>
              );
            })}
          </div>
          <div className="sub-footer">
            <div className="sub-footer-row">
              <div className="social-media">
                {socialMediaLinks.map((link, i) => {
                  const linkIndex = i;
                  return (
                    <a
                      href={link.get('href')}
                      key={`social-media-${linkIndex}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FontAwesome name={link.get('icon')} />{' '}
                      <span className="hidden-text"> {link.get('text')}</span>
                    </a>
                  );
                })}
              </div>
              <div className="t-and-cs">
                <a
                  href={TOS_GENERAL_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Terms of service
                </a>
                <a
                  href={PRIVACY_POLICY_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Privacy policy
                </a>
              </div>
            </div>
            <div className="footer-copyright">
              &copy; {copyrightYear} Open Learning Global Pty Ltd
            </div>
          </div>
        </div>
      </div>
    </default-footer>
  );
};
